import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import type { PVEmployeeAuditResult } from "@/types";
import { StagePanel } from "./StagePanel";
import { ConfigSummary } from "./ConfigSummary";

interface EmployeeDrillDownProps {
	employee: PVEmployeeAuditResult;
	organizationId: string;
	periodStart: string;
	periodEnd: string;
	onBack: () => void;
}

const STAGE_LABELS: Record<string, string> = {
	config: "Config",
	attendance: "Attendance",
	leave: "Leave",
	timesheet: "Timesheet",
	payroll: "Payroll",
	payslip: "Payslip",
	weekend: "Weekend",
};

export function EmployeeDrillDown({
	employee,
	onBack,
}: EmployeeDrillDownProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-center gap-3">
				<Button variant="ghost" size="sm" onClick={onBack}>
					<ArrowLeft className="mr-2 h-4 w-4" />
					Back to results
				</Button>
				<div>
					<h3 className="font-semibold">{employee.employeeName}</h3>
					<p className="text-sm text-muted-foreground">
						{employee.salaryBasis} · {employee.employmentType} ·{" "}
						{employee.passedChecks}/{employee.totalChecks} passed
					</p>
				</div>
			</div>

			<ConfigSummary configSummary={employee.configSummary} />

			{Object.entries(employee.stages).map(([stageName, stageResult]) => (
				<Card key={stageName}>
					<CardContent className="pt-4">
						<h4 className="font-medium mb-3">
							{STAGE_LABELS[stageName] ?? stageName}
						</h4>
						<StagePanel checks={stageResult.checks} />
					</CardContent>
				</Card>
			))}
		</div>
	);
}
